module.exports = __webpack_public_path__ + "static/img/2.9c1a2bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/2.png
// module id = 35d7
// module chunks = 0